@use '@design/design-tokens/typography/typography' as *;

.eventDateRoot {
  display: flex;
  flex-direction: column;
  min-width: fit-content;
}

.title {
  @include typography-v2-body-sm;
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-primary);

  svg {
    fill: currentColor;
  }

  &.reported {
    color: var(--text-success);
  }
}

.description {
  @include typography-v2-body-base;
  color: var(--text-default);
}
